import {
  CONFIG
} from '../actions/global'

const initialState = {
  config: {
    // DEV CONFIGS HERE
    clientId: '0oa12izonvzPofNmi0h8',
    baseURL: 'https://api.fax.dev.docutech.app',
    authBaseUrl: 'https://docutech.oktapreview.com/oauth2/ausyjhsvwkb06KTtW0h7/v1',
    FC_BaseUrl: 'https://qa.print.qa.docutech.app/oktaapi/v1/Packages',
    loginURL: {
      params: 'client_id=0oa12izonvzPofNmi0h8&response_type=code&scope=offline_access+openid+profile&redirect_uri=http://localhost:3000/login/callback'
    },
    features: {
      thirdPartyActive: true, // OKTA
      earliestSigningDate: true // OKTA
    }
  },
  loading: false,
  error: ''
}

const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG:
      return {
        ...state,
        config: action.config,
        loading: false,
        error: ''
      }
    default:
      return state
  }
}

export default globalReducer
